import { render, staticRenderFns } from "./report-face.vue?vue&type=template&id=61dbfcca&scoped=true&"
import script from "./report-face.vue?vue&type=script&lang=ts&"
export * from "./report-face.vue?vue&type=script&lang=ts&"
import style0 from "./report-face.vue?vue&type=style&index=0&id=61dbfcca&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61dbfcca",
  null
  
)

export default component.exports